import React from 'react'
import { Space, Tooltip } from 'antd'
import { TruckOutlined, WarningOutlined, CheckCircleOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'

export interface RepairKitDeliveryInfo {
  status: 'waiting' | 'overdue' | 'attention' | 'blocked' | 'ready'
  message: string
  delivery_date: string | null
  completion_date: string | null
  deliveries: { id: number; number: string; date: string | null; stage: string }[]
}

export const RepairKitDeliveryIndicator: React.FC<{
  info?: RepairKitDeliveryInfo | null
  showText?: boolean
}> = ({ info, showText }) => {
  if (!info) return null
  const warning = ['overdue', 'attention', 'blocked'].includes(info.status)
  const color = warning ? '#ad6800' : info.status === 'ready' ? '#389e0d' : '#1677ff'
  const Icon = warning
    ? WarningOutlined
    : info.status === 'ready'
    ? CheckCircleOutlined
    : TruckOutlined
  const date = info.delivery_date ? dayjs(info.delivery_date).format('DD.MM.YYYY') : null
  const label =
    info.status === 'waiting'
      ? 'Ожидает доставку ремкомплекта'
      : info.status === 'ready'
      ? 'Ремкомплект доставлен'
      : 'Ремкомплект: требуется внимание'
  return (
    <Tooltip
      trigger={['hover', 'focus']}
      title={
        <div>
          <div>{info.message}</div>
          {date && (
            <div>
              {info.deliveries.length ? 'Дата в логистике' : 'Плановая дата'}: {date}
            </div>
          )}
          {info.deliveries.map(delivery => (
            <div key={delivery.id}>
              Переделка {delivery.number}:{' '}
              {delivery.date ? dayjs(delivery.date).format('DD.MM.YYYY') : 'дата не указана'}
              {delivery.stage === 'done'
                ? ' — выполнена'
                : delivery.stage === 'cancelled'
                ? ' — отменена'
                : ''}
            </div>
          ))}
        </div>
      }
    >
      <span
        tabIndex={0}
        role="img"
        aria-label={`${info.message}${date ? `. Дата доставки: ${date}` : ''}`}
        style={{ color, cursor: 'help', display: 'inline-flex', alignItems: 'center' }}
        onClick={event => event.stopPropagation()}
      >
        <Space size={4}>
          <Icon style={{ fontSize: 17 }} />
          {showText && (
            <span>
              {label}
              {date ? ` · ${date}` : ''}
            </span>
          )}
        </Space>
      </span>
    </Tooltip>
  )
}
